import type { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { InstallationCreateReviewSummary } from '@/features/installations/components/installation-create/installation-create-review-summary'
import type {
  InstallationCreateFormInput,
  InstallationGoodsFamily,
} from '@/features/installations/installation-create.schema'

type InstallationCreateStepReviewProps = {
  form: UseFormReturn<InstallationCreateFormInput>
  requiresLocalNameAndAddress: boolean
  placeOfRegistration: string
}

export function InstallationCreateStepReview({
  form,
  requiresLocalNameAndAddress,
  placeOfRegistration,
}: InstallationCreateStepReviewProps) {
  const { t } = useTranslation('installations')

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('create.wizard.steps.review.title')}</CardTitle>
        <CardDescription>{t('create.wizard.steps.review.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <InstallationCreateReviewSummary
          values={form.getValues()}
          requiresLocalNameAndAddress={requiresLocalNameAndAddress}
          placeOfRegistration={placeOfRegistration}
          translateField={(key) => t(key)}
          translateGoodsFamily={(value: InstallationGoodsFamily) =>
            t(`create.fields.goodsFamily.options.${value}`)
          }
        />
      </CardContent>
    </Card>
  )
}
